import React from "react";
import ContentCard from "@/components/ContentCard";
import PageLayout from "@/components/PageLayout";

const Guide = () => {
  return (
    <PageLayout
      title="Skadis Layout Planning Guide"
      description="A practical guide for measuring a space, choosing a print profile, and reading the Skadisfinity visual preview."
    >
      <ContentCard title="Start With The Real Space">
        <p>
          Measure the usable area rather than the outer edge of a wall, shelf,
          or drawer. Leave room for nearby handles, brackets, cable paths, desk
          legs, and anything else that would block a printed board from sitting
          flat. If the layout will be mounted inside a frame or drawer, measure
          the internal opening.
        </p>
        <p>
          Skadisfinity accepts inches or millimeters. Millimeters are usually
          easier for 3D printing because printer build volumes and printable
          board sizes are specified in millimeters.
        </p>
      </ContentCard>

      <ContentCard title="Choose A Printer Profile">
        <p>
          A board layout is only useful if every piece can fit on the selected
          printer. Choose a known printer preset when available, or enter a
          custom build volume that matches your slicer. If your printer cannot
          fit a full 240mm-by-240mm board, the calculator will use smaller
          pieces that fit the available plate.
        </p>
        <p>
          For printers with very similar build volumes, check the actual usable
          area in the slicer. Purge lines, clips, textured plate margins, or
          printer-specific exclusions can reduce the printable region.
        </p>
      </ContentCard>

      <ContentCard title="Read The Visual Preview">
        <p>
          The preview shows the calculated boards and any trim areas left over
          after the selected pieces are placed. A narrow trim strip means the
          layout nearly fills the requested space. A larger spacer area may be
          acceptable for hidden edges, but it is worth reviewing before printing
          a large set of panels.
        </p>
        <p>
          When comparing layouts, prefer the result that uses the maximum useful
          board area with the least trim, as long as the board count and print
          time still make sense for the project.
        </p>
      </ContentCard>

      <ContentCard title="Before You Print">
        <ul className="list-disc space-y-2 pl-6">
          <li>Confirm the selected units match your measurement.</li>
          <li>Confirm the printer preset matches the printer and build plate.</li>
          <li>Check whether the Default or AU3D profile better fills the space.</li>
          <li>Review trim locations so thin pieces do not land on visible edges.</li>
          <li>Print a small test section if you are using a new board model.</li>
        </ul>
      </ContentCard>
    </PageLayout>
  );
};

export default Guide;
